import styled from 'styled-components';
const gridLength = 9;
const spacing = 12;
export const Item = styled.div<{ size: number }>`
	width: ${(props) => (props.size / gridLength) * 100}%;
`;
export const Row = styled.div`
	display: flex;
	flex-wrap: wrap;
`;
export const Grid = styled.div`
	${Item} {
		padding: ${spacing}px;
	}
	${Row} {
		margin: 0 -${spacing}px;
	}
`;
